import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const raisedClaimNSightPatch = async (data: object) => {
  return axios.put(endpoints.claimRaisedNSightPatch, data)
}

export const useRaisedClaimNSightPatch = () => {
  const queryClient = useQueryClient()
  return useMutation(raisedClaimNSightPatch, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.N_SIGHT_PATCH_Listing, ApiKey.list])
    },
  })
}
